module.exports = __webpack_public_path__ + "static/media/bg.a8e8195f.png";